module.exports = require('crypto');